/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import Request from '../../utils/request';
import utils from '../../utils/utils';
import "./style.less";

class PipelineSchoolLottery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visiable: false,
      pageId: utils.getPageId(),
      is_vote: 0,
      is_can_enter: false,
      is_has_enter: false,
      is_receive: false,
      is_lottery: false,
      receive_prizes: {
        style_id: null,
        name: '',
        img: ''
      },
      prizes: [],
      award_text: '',
      winningPopup: false
    };
    this.init = false;
    this.isLock = false;
    this.isShihuo = utils.isShihuo();
  }

  componentDidMount() {
    const { acticityScene } = this.props.config;
    this.createScript();

    if (acticityScene !== '社区投票') {
      this.getActivityDetail();
    } else {
      this.getCommunityActDetail();
    }

    document.addEventListener(
      "visibilitychange",
      () => {
        if (document.hidden) {
          return;
        } else {
          // 刷新秒杀状态
          if (acticityScene !== '社区投票') {
            this.getActivityDetail();
          } else {
            this.getCommunityActDetail();
          }
          return;
        }
      },
      false
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lotteryState) {
      this.props.updateLotteryState(false);
      this.getCommunityActDetail();
    }
  }

  // 校园活动抽奖详情
  getActivityDetail = async() => {
    let { data = {} } = await Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/delivery/basketball/lottery/offline/detail',
      method: "get",
      withCredentials: true,
      params: {
        lottery_code: this.state.pageId
      },
    });
    if (data.status === 0) {
      this.setState({
        prizes: data.data.prizes,
        receive_prizes: data.data.receive_prizes,
        is_can_enter: data.data.is_can_enter,
        is_receive: data.data.is_receive,
        is_has_enter: data.data.is_has_enter,
        is_lottery: data.data.is_receive || (!data.data.is_receive && data.data.is_has_enter),
        award_text: data.data.award_text
      }, () => {
        const initSlotMachine = setInterval(() => {
          if (window.SlotMachine && !this.init) {
            clearInterval(initSlotMachine);
            setTimeout(() => {
              const { prizes = [], is_receive, receive_prizes = {} } = data.data;
              if (is_receive && receive_prizes && receive_prizes.style_id) {
                const activeIdx = prizes.findIndex(item => item.style_id === receive_prizes.style_id);
                this.initGames(activeIdx);
              } else {
                this.initGames();
              }
            }, 600);
          }
        }, 50);
      })
    } else {
      window.Jockey.send('toast', {
        text: data.msg
      });
    }
  }

  // 社区投票抽奖详情
  getCommunityActDetail = async(update = false) => {
    let { data = {} } = await Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/delivery/lottery/award',
      method: "get",
      withCredentials: true,
      params: {
        code: this.state.pageId
      },
    });
    if (data.status === 0) {
      const { prizes, receive_prizes, is_vote, is_can_enter, is_receive, is_has_enter, award_text } = data.data;
      const is_lottery = is_receive || (!is_receive && is_has_enter);
      this.setState({
        is_lottery: update ? false : is_lottery,
        receive_prizes,
        is_vote,
        is_can_enter,
        is_receive,
        is_has_enter,
        award_text,
        prizes
      }, () => {
        const initSlotMachine = setInterval(() => {
          if (window.SlotMachine && !this.init) {
            clearInterval(initSlotMachine);
            setTimeout(() => {
              if (is_receive && receive_prizes && receive_prizes.style_id) {
                const activeIdx = prizes.findIndex(item => item.style_id === receive_prizes.style_id);
                this.initGames(activeIdx);
              } else {
                this.initGames();
              }
            }, 600);
          }
        }, 50);
      })
    } else {
      window.Jockey.send('toast', {
        text: data.msg
      });
    }
  }

  // 初始化动画
  initGames = (activeIdx) => {
    const casino1 = document.querySelector('#casino1');
    const casino2 = document.querySelector('#casino2');
    const casino3 = document.querySelector('#casino3');

    this.init = true;
    this.mCasino1 = window.SlotMachine && new window.SlotMachine(casino1, {
      active: activeIdx || activeIdx == 0 ? activeIdx : 0,
      delay: 500,
      transition: "ease-in-out",
      direction: "down",
      distance: 20.5,
      onComplete: () => {
        this.mCasino2.stop();
      }
    });
    this.mCasino2 = window.SlotMachine && new window.SlotMachine(casino2, {
      active: activeIdx || activeIdx == 0 ? activeIdx : 1,
      delay: 500,
      transition: "ease-in-out",
      direction: "down",
      distance: 20.5,
      onComplete: () => {
        this.mCasino3.stop();
      }
    });
    this.mCasino3 = window.SlotMachine && new window.SlotMachine(casino3, {
      active: activeIdx || activeIdx == 0 ? activeIdx : 2,
      delay: 500,
      transition: "ease-in-out",
      direction: "down",
      distance: 20.5,
      onComplete: () => {
        this.isLock = false;
        const { is_can_enter, is_receive, is_has_enter, receive_prizes = {} } = this.state;
        const is_lottery = true;
        this.setState({
          is_lottery,
          winningPopup: (receive_prizes && receive_prizes.style_id) ? true: false
        })
      }
    });

    this.setState({
      visiable: true
    });
  }

  // 校园活动抽奖
  handleLottery = async() => {
    const CookieUA = await utils.getCookie('ua');
    const CookieU = await utils.getCookie('u');

    if ((!CookieUA || !CookieU) && !window.isLogin) {
      // 未登录
      window.Jockey.send("action", {
        url: "shihuo://www.shihuo.cn?route=login",
      });
      return;
    }

    if (!this.state.is_can_enter) {
      window.Jockey.send('toast', {
        text: '暂无抽奖机会'
      });
      return;
    }
    if (this.isLock) {
      return;
    }
    this.isLock = true;

    let { data = {} } = await Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/delivery/basketball/lottery/offline/start',
      method: 'post',
      withCredentials: true,
      data: {
        lottery_code: this.state.pageId
      },
    });
    if (data.status === 0) {
      this.setState({
        is_receive: data.data.is_receive,
        is_can_enter: data.data.is_can_enter,
        receive_prizes: data.data.receive_prizes,
        is_has_enter: true
      }, () => {
        if (data.data.is_receive) {
          const { style_id } = data.data.receive_prizes;
          const stopIdx = this.state.prizes.findIndex(item => item.style_id === style_id);
          this.playGames(stopIdx);
        } else {
          this.playGames();
        }
      });
    } else {
      window.Jockey.send('toast', {
        text: data.msg
      });
    }
  }

  // 社区投票活动抽奖
  handleCommunityLottery = async() => {
    const CookieUA = await utils.getCookie('ua');
    const CookieU = await utils.getCookie('u');

    if (!CookieUA || !CookieU) {
      // 未登录
      window.Jockey.send("action", {
        url: "shihuo://www.shihuo.cn?route=login",
      });
      return;
    }

    const { is_vote, is_can_enter, is_has_enter, is_receive } = this.state;

    if (!is_receive) {
      if (!is_can_enter) {
        if (is_vote === 0) {
          window.Jockey.send('toast', {
            text: '投票后可参与抽奖'
          });
        } else {
          window.Jockey.send('toast', {
            text: '暂无抽奖机会'
          });
        }
        return;
      } 
    } else {
      return;
    }

    if (this.isLock) {
      return;
    }
    this.isLock = true;

    let { data = {} } = await Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/delivery/lottery/award',
      method: 'post',
      withCredentials: true,
      data: {
        code: this.state.pageId
      },
    });
    if (data.status === 0) {
      const { is_receive, receive_prizes = {} } = data.data;
      this.setState({
        is_receive,
        receive_prizes,
        is_has_enter: true
      }, () => {
        if (is_receive) {
          const { style_id } = receive_prizes;
          const stopIdx = this.state.prizes.findIndex(item => item.style_id === style_id);
          this.playGames(stopIdx);
        } else {
          this.playGames();
        }

        // 抽奖完刷新详情接口
        this.getCommunityActDetail(true);
      });
    } else {
      window.Jockey.send('toast', {
        text: data.msg
      });
    }
  }

  // 播放动画
  playGames = (stopIdx) => {
    this.mCasino1.shuffle(100, (stopIdx || stopIdx == 0) ? stopIdx : 0);
    this.mCasino2.shuffle(100, (stopIdx || stopIdx == 0) ? stopIdx : 1);
    this.mCasino3.shuffle(100, (stopIdx || stopIdx == 0) ? stopIdx : 2);

    setTimeout(() => {
      this.mCasino1.stop();
    }, 2000);
  }

  // 中奖弹窗
  renderWinningPopup() {
    const { receive_prizes = {} } = this.state;
    return (
      <Fragment>
        <div className="mask"></div>
        <div className="winning-popup">
        <div className="success-info">
          {
            receive_prizes && receive_prizes.style_id && (
              <Fragment>
                <div className="prize-info">
                  <img
                    src={receive_prizes.img}
                    className="prize-image"
                  />
                  <p className="prize-name">{receive_prizes.name}</p>
                </div>
                <img
                  src="https://sh1.shihuocdn.cn/images/bargain/close.png"
                  alt=""
                  className="close"
                  onClick={() => this.setState({winningPopup: false})}
                />
              </Fragment>
            )
          }
        </div>
        </div>
      </Fragment>
    )
  }

  render() {
    const { acticityScene, lotteryBgImage, lotteryCoverImage, lotteryBtnImage, lotteryHasJoinBtnImage } = this.props.config;
    const { visiable, prizes, is_can_enter, is_has_enter, is_receive, is_lottery, receive_prizes = {}, award_text, winningPopup } = this.state;
    return (
      <div
        ref={ele => {
          if (ele) {
            this.props.exp && this.props.exp(ele);
          }
        }}
        data-dot={JSON.stringify(utils.getExposureData(this.props))}
        className="pipeline-schoolLottery"
        {...this.props['customAttributes']}
      >
        <div
          className="games-area"
          style={{
            backgroundImage: `url(${lotteryBgImage || 'https://static.shihuocdn.cn/admin/files/20240411/0e3c1650c7335851cba16e40f51c90a8.png'})`
          }}
        >
          <ul className="games-content fadeIn">
            <li
              id="casino1"
              className={visiable ? 'show' : 'hide'}
            >
              {
                prizes && prizes.length > 0 && prizes.map((item, index) => {
                  if (item.img) {
                    return (
                      <div
                        className="prize-item-wrap"
                        key={index}
                      >
                        <img
                          src={item.img}
                          alt=""
                          className={`slot slot${index}`}
                          key={index}
                        />
                      </div>
                    )
                  } else {
                    return null
                  }
                })
              }
            </li>
            <li
              id="casino2"
              className={visiable ? 'show' : 'hide'}
            >
              {
                prizes && prizes.length > 0 && prizes.map((item, index) => {
                  if (item.img) {
                    return (
                      <div
                        className="prize-item-wrap"
                        key={index}
                      >
                        <img
                          src={item.img}
                          alt=""
                          className={`slot slot${index}`}
                          key={index}
                        />
                      </div>
                    )
                  } else {
                    return null
                  }
                })
              }
            </li>
            <li
              id="casino3"
              className={visiable ? 'show' : 'hide'}
            >
              {
                prizes && prizes.length > 0 && prizes.map((item, index) => {
                  if (item.img) {
                    return (
                      <div
                        className="prize-item-wrap"
                        key={index}
                      >
                        <img
                          src={item.img}
                          alt=""
                          className={`slot slot${index}`}
                          key={index}
                        />
                      </div>
                    )
                  } else {
                    return null
                  }
                })
              }
            </li>
          </ul>
          <img
            src={
              is_can_enter 
                ? (lotteryBtnImage || "https://static.shihuocdn.cn/admin/files/20240411/a6258e964f00118b57a65fbb779a9aae.png")
                : (
                  is_has_enter 
                    ? (lotteryHasJoinBtnImage || "https://static.shihuocdn.cn/admin/files/20240411/1375350d353bab59e675db435fa6f368.png")
                    : (lotteryBtnImage || "https://static.shihuocdn.cn/admin/files/20240411/a6258e964f00118b57a65fbb779a9aae.png")
                )
            }
            alt=""
            className="lucky-btn"
            onClick={() => {
              if (acticityScene !== '社区投票') {
                this.handleLottery();
              } else {
                this.handleCommunityLottery();
              }
            }}
          />
          <img
            src={ lotteryCoverImage || 'https://static.shihuocdn.cn/admin/files/20240411/991ffb314f8cad83615ecda2f883780a.png'}
            alt=""
            className="games-cover"
          />
        </div>
        {
          is_lottery && (
            <p className="result">
              {
                is_receive ? `恭喜获得【${receive_prizes.name}】${award_text ? '，' + award_text : ''}` : '很遗憾未中奖'
              }
            </p>
          )
        }
        {
          winningPopup && this.renderWinningPopup()
        }
      </div>
    )
  }

  createScript = () => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.type = "text/javascript";
    script.src = "https://www.shihuo.cn/js/lib/vFramePlayer.min.js";
    head.appendChild(script);
  }

}

export { PipelineSchoolLottery };
export default PipelineSchoolLottery;



// WEBPACK FOOTER //
// ./components/pipeline-schoolLottery/index.js